import { useEffect } from 'react'
import usePopupStore from '../../../../../store/usePopupStore'
import BottomSheet from '../BottomSheet/BottomSheet'
import BasicModal from './BasicModal'
import CalendarModal from './CalendarModal'

export enum WebviewModalType {
  webview_basic_modal = 'webview_basic_modal',
  webview_calendar_modal = 'webview_calendar_modal',
  webview_btm_sheet = 'webview_btm_sheet',
}

export const useWebviewModal = () => {
  const popupShow = usePopupStore((state) => state.show)
  const popupClose = usePopupStore((state) => state.close)

  const show = (props: { id; body; onClose?; btnLabel?; title?; buttons? }) => {
    popupShow({ ...props, type: WebviewModalType.webview_basic_modal })
  }
  const close = (id) => {
    popupClose({ id })
  }
  return { show, close }
}

export const useWebviewCalendarModal = () => {
  const popupShow = usePopupStore((state) => state.show)
  const popupClose = usePopupStore((state) => state.close)

  const show = (props: { id; body; onClose?; buttons? }) => {
    popupShow({ ...props, type: WebviewModalType.webview_calendar_modal })
  }
  const close = (id) => {
    popupClose({ id })
  }
  return { show, close }
}

export const useWebviewBottomSheet = () => {
  const popupShow = usePopupStore((state) => state.show)
  const popupClose = usePopupStore((state) => state.close)

  const show = (props: { id; onClose?; bottomSheetList?; customBody?; title? }) => {
    popupShow({ ...props, type: WebviewModalType.webview_btm_sheet })
  }
  const close = (id) => {
    popupClose({ id })
  }
  return { show, close }
}

export const WebviewModal = ({ id }: { id: any }) => {
  const popupClose = usePopupStore((state) => state.close)
  const { data } = usePopupStore((state) => ({
    data: state.data[id],
  }))

  useEffect(() => {
    return () => {
      popupClose({ id })
    }
  }, [])

  return (
    <div id={id} className="cursor-none select-none">
      {data.type === WebviewModalType.webview_basic_modal && <BasicModal id={id} />}
      {data.type === WebviewModalType.webview_calendar_modal && <CalendarModal id={id} />}
      {data.type === WebviewModalType.webview_btm_sheet && <BottomSheet id={id} />}
    </div>
  )
}
